import { Event } from '../../../../types/event';

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export function formatShiftCommunitySummary(shift: Event, t: TranslateFn): string | null {
  if (!shift.communityAssignments?.length) {
    return null;
  }

  return shift.communityAssignments
    .map((assignment) =>
      t('page.event.schedules.communities.summary', {
        name: assignment.communityName,
        assigned: assignment.assignedCount,
        required: assignment.requiredCount,
      }),
    )
    .join(' · ');
}
